import * as React from "react";

const TagIcon = (props: { className?: string, fill: string }) => (
  <svg
  className={props.className}
  fill={props.fill} 
  version="1.1" 
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 300 300">
  <path d="M146.4,254.6c-22.8,0-45.6,0-68.5,0c-12.1,0-15.2-3-15.2-14.9c0-31.1,0-62.3,0-93.4c0-10.1,2.1-12.8,11.4-17.1
    c26.5-12.2,42.3-32.5,46.4-61.6c0.6-4.1,0.7-8.3,1.1-12.4c1.4-14.4,11.9-24,26-23.6c14.3,0.4,23.8,10.1,24.6,24.8
    c1.8,33.2,15.9,58.8,47.1,72.9c7.9,3.6,10.8,8.7,10.7,17.4c-0.4,31-0.2,62-0.1,92.9c0,11.7-2.9,15-14.6,15
    C192.4,254.6,169.4,254.6,146.4,254.6z M147.3,61.9c3.9-0.2,6-2.4,6-6c0-3.8-2.5-5.7-6.1-5.8c-3.6,0-5.5,2.2-5.5,5.7
    C141.7,59.5,143.6,61.7,147.3,61.9z"/>
  </svg>
);

const NextIcon = (props: { className?: string, fill: string }) => (

  <svg 
  xmlns="http://www.w3.org/2000/svg" 
  width="22" 
  height="17.6" 
  viewBox="0 0 22 17.6"
  className={props.className}
  fill={props.fill} 
  >
    <path  d="M15.2,4a1.063,1.063,0,0,1,.782.318l7.7,7.7a1.121,1.121,0,0,1,0,1.564l-7.7,7.7a1.106,1.106,0,0,1-1.564-1.564L20.245,13.9H3.1a1.1,1.1,0,0,1,0-2.2H20.245L14.418,5.882A1.063,1.063,0,0,1,14.1,5.1,1.072,1.072,0,0,1,15.2,4Z" transform="translate(-2 -4)"/>
  </svg>
);

const BackIcon = (props: { className?: string, fill: string }) => (

  <svg 
  xmlns="http://www.w3.org/2000/svg" 
  width="22" 
  height="17.6" 
  viewBox="0 0 22 17.6"
  className={props.className}
  fill={props.fill} 
  >
   <path d="M10.8,4a1.1,1.1,0,0,1,1.1,1.1,1.049,1.049,0,0,1-.327.782L5.755,11.7H22.9a1.1,1.1,0,0,1,0,2.2H5.755l5.818,5.818a1.049,1.049,0,0,1,.327.782,1.106,1.106,0,0,1-1.882.782l-7.7-7.7a1.121,1.121,0,0,1,0-1.564l7.7-7.7A1.082,1.082,0,0,1,10.8,4Z" transform="translate(-2 -4)"/>
   </svg>
);


const DeleteIcon = (props: { className?: string, fill: string }) => (

  <svg 
  xmlns="http://www.w3.org/2000/svg" 
  width="15" 
  height="15" 
  viewBox="0 0 22 22"
  className={props.className}
  fill={props.fill} 
  >
   <path  d="M24.625,4A1.34,1.34,0,0,1,26,5.375a1.329,1.329,0,0,1-.4.978L16.944,15,25.6,23.647A1.383,1.383,0,0,1,23.647,25.6L15,16.944,6.353,25.6a1.329,1.329,0,0,1-.978.4A1.383,1.383,0,0,1,4.4,23.647L13.056,15,4.4,6.353A1.329,1.329,0,0,1,4,5.375,1.34,1.34,0,0,1,5.375,4a1.329,1.329,0,0,1,.978.4L15,13.056,23.647,4.4a1.329,1.329,0,0,1,.978-.4Z" transform="translate(-4 -4)"/>
</svg>
);

const EditIcon = (props: { className?: string, fill: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" 
    className={props.className}
    fill={props.fill}
  width="22" 
  height="22" 
  viewBox="0 0 32 32">
   
   <path  d="M26,27.22a27.38,27.38,0,0,0-6-.95c-2.61,0-6.14,2.06-9.17,2.06a24,24,0,0,1-6.39-1.11"/>
  <rect  x="14.45" y="2.74" width="6.37" height="21.76" transform="translate(20.48 35.72) rotate(-135)"/>
  <polygon  points="5.85 25.49 12.14 23.62 7.63 19.12 5.85 25.49"/>
  <line  x1="6.47" y1="24.86" x2="4.67" y2="26.67"/>
  <line x1="24.92" y1="6.42" x2="10.44" y2="20.89"/>

   </svg>
  );
  




const MailIcon = (props: { className?: string, fill: string }) => (
<svg xmlns="http://www.w3.org/2000/svg" 
  className={props.className}
  fill={props.fill}
width="22" 
height="18" 
viewBox="0 0 22 18">
 
 <path d="M4,3H20a2.89,2.89,0,0,1,2.121.879A2.89,2.89,0,0,1,23,6V18a3,3,0,0,1-3,3H4a2.89,2.89,0,0,1-2.121-.879A2.89,2.89,0,0,1,1,18V6a2.89,2.89,0,0,1,.879-2.121A2.89,2.89,0,0,1,4,3ZM21,18V7.078l-8.375,6.7a1,1,0,0,1-1.25,0L3,7.078V18a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1ZM20,5H4a1.132,1.132,0,0,0-.328.055L12,11.719l8.328-6.664A1.132,1.132,0,0,0,20,5Z" 
 transform="translate(-1 -3)"/>
 </svg>
);

export {
  TagIcon,
  NextIcon,
  MailIcon,
  BackIcon,
  DeleteIcon,
  EditIcon
};




